// extracted by mini-css-extract-plugin
export default {"title":"Title_title__g-FrF","image":"Title_image__+KH3v"};